import * as React from 'react';

import { parseHHmm } from './utils';

interface CurrentTimeIndicatorProps {
  workingStart: string;
  workingEnd: string;
  slotHeightPx: number;
  containerWidthPx: number;
  leftOffsetPx: number;
  label: string;
}

export function CurrentTimeIndicator({
  workingStart,
  workingEnd,
  slotHeightPx,
  containerWidthPx,
  leftOffsetPx,
  label,
}: CurrentTimeIndicatorProps) {
  const [now, setNow] = React.useState(() => new Date());

  React.useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 60_000);
    return () => window.clearInterval(id);
  }, []);

  const { h: sH, m: sM } = parseHHmm(workingStart);
  const { h: eH, m: eM } = parseHHmm(workingEnd);
  const startMin = sH * 60 + sM;
  const endMin = eH * 60 + eM;
  const nowMin = now.getHours() * 60 + now.getMinutes();
  if (nowMin < startMin || nowMin > endMin) return null;

  const offsetMin = nowMin - startMin;
  const top = (offsetMin / 30) * slotHeightPx;

  return (
    <div
      className="pointer-events-none absolute z-30 flex items-center"
      style={{ top, left: leftOffsetPx, width: containerWidthPx }}
      aria-hidden="true"
    >
      <span className="font-mono-num text-[10px] font-bold uppercase tracking-wider text-biz-now bg-biz-bg px-1.5 py-0.5 rounded animate-biz-now-pulse">
        {label}
      </span>
      <span className="h-px flex-1 bg-biz-now" />
      <span className="h-2 w-2 rounded-full bg-biz-now -ml-0.5" />
    </div>
  );
}
